/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable object-curly-newline */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Environments from "../../Environments";
import { CAREER_TYPE_CLASSROOM, CAREER_TYPE_CURRICULUM, CAREER_TYPE_ELEARNING } from "../../Constants";
import MOCK_DATA from "../../mock/data";

import BaseFrame from "../../component/wrapper/BaseFrame";
import { HomeLink } from "../../component/breadcrums/Links";
import { useScreenSize } from "../../component/Theme";
import FilterTag from "../../component/filter/FilterTag";
import SompoLoading from "../../component/loading/SompoLoading";
import SkillDrawer from "./SkillDrawer";
import NoData from "../../component/NoData";

import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import SkillMapCellService, { SkillMapCellResponse } from "../../logic/api/SkillMapCellService";
import OnGoingSkmGridListService, { OnGoingSKMGridListItem, OnGoingSkmGridListResponse } from "../../logic/api/OnGoingSkmGridListService";
import CareerInfoClassInfoService, { CareerInfoClassInfoResponse } from "../../logic/api/CareerInfoClassInfoService";
import CurriculumInfoService, { CurriculumInfo, CurriculumInfoResponse } from "../../logic/api/CurriculumInfoService";
import SkillMapRootDataService, { SkillMapRootDataResponse } from "../../logic/api/SkillMapRootDataService";
import getSkillMapFieldTree, { SkillMapFieldTree } from "../../logic/skill/getSkillMapFieldTree";
import SompoContext from "../../logic/context/SompoContext";
import { Categories, CATEGORIES_DEFAULT, useCategories2 } from "../../logic/hook/useCategories";

export interface SkillProps {
    setTrainingDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setRenderCount: React.Dispatch<React.SetStateAction<number>>;
    renderCount: number;
    trainingDrawerOpen: boolean;
    skillMapCell: SkillMapCellResponse;
    cmId: string;
    skillMapFieldTitle: string;
    compulsoryIdList: { [careerId: string]: string };
    rootId: string;
    skillMapRootData: SkillMapRootDataResponse;
    categories: Categories;
}
const skillMapCellService = new SkillMapCellService();
const skillMapService = new OnGoingSkmGridListService();
const skillMapRootDataService = new SkillMapRootDataService();
const careerInfoClassInfoService = new CareerInfoClassInfoService();
const curriculumService = new CurriculumInfoService();

interface SkillMapName {
    id: string;
    name: string;
}

// リンク文字のスタイル
const TypographyLinkStyle = {
    fontWeight: "bold",
    textDecoration: "underline",
    transition: "all 0.2s ease-in-out",
    color: "#29267A",
    "&:hover": {
        opacity: 0.7,
        cursor: "pointer",
    },
};

const cellBorder = { border: "1.5px solid #999" };

// 実際に表示されるコンポーネント
const Content = () => {
    const { desktop } = useScreenSize();
    const [renderCount, setRenderCount] = useState(0);
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用
    const [cmId, setCmId] = useState(""); // 選択したスキルマップのID
    const [skillMapField, setSkillMapField] = useState<SkillMapFieldTree>({} as SkillMapFieldTree); // 分野取得用
    const [skillMaps, setSkillMaps] = useState<OnGoingSKMGridListItem[]>([]); // スキルマップ取得用
    const [trainingDrawerOpen, setTrainingDrawerOpen] = useState(false); // 講座ドロワー用
    const [skillMapFieldTitle, setSkillMapFieldTitle] = useState(""); // 選択したスキル名
    const [skillMapCell, setSkillMapCell] = useState<SkillMapCellResponse>({} as SkillMapCellResponse); // レベル取得用
    const [compulsoryIdList, setCompulsoryIdList] = React.useState<{ [careerId: string]: string }>({});
    const [skillMapRootData, setSkillMapRootData] = useState<SkillMapRootDataResponse>({} as SkillMapRootDataResponse); // 単一分野のスキルマップデータ取得用
    const [rootId, setRootId] = useState(""); // 選択したスキルマップの1階層目のFieldId
    const { fetchCategories } = useCategories2();
    const [categories, setCategories] = useState<Categories>(CATEGORIES_DEFAULT);

    // フィルタータグ選択時に発火。
    const handleFilterTagChange = (name: string, id: string) => {
        setCmId(id);
    };

    // 初期表示時にスキルマップを取得
    useEffect(() => {
        sompoContext.setLoading(true);
        if (!Environments.MOCK) {
            const fetch = async () => {
                await skillMapService.onGoingSkmGridList(
                    (_skillMap: OnGoingSkmGridListResponse) => {
                        setSkillMaps(_skillMap.onGoingSKMGridList);
                        sompoContext.setLoading(false);
                    },
                    (error: any) => {
                        console.error(error);
                        showErrorMessage({ message: "スキルマップの取得に失敗しました。", error });
                        setSkillMaps([]);
                        sompoContext.setLoading(false);
                    }
                );
            };
            fetch();
        } else {
            setSkillMaps(MOCK_DATA.USER.SKILL_MAP.ON_GOING);
            sompoContext.setLoading(false);
        }
    }, []);

    // スキルマップフィルター作成のため、名前とIDの配列を作成する
    const skillMapNames: SkillMapName[] = [];
    skillMaps.forEach((skillMapItem) => {
        skillMapNames.push({
            name: skillMapItem.cmtitle,
            id: skillMapItem.cmid,
        });
    });

    // スキルマップフィルター選択時に成形されたスキルマップデータを取得
    useEffect(() => {
        sompoContext.setSkillMapLoading(true);
        if (cmId) {
            // スキルマップが選択されている場合
            if (!Environments.MOCK) {
                const fetch = async () => {
                    try {
                        if (Environments.DEBUG) {
                            await new Promise((resolve) => {
                                setTimeout(resolve, 500);
                            });
                        }
                        setSkillMapField(await getSkillMapFieldTree(cmId));
                        sompoContext.setSkillMapLoading(false);
                    } catch (error: any) {
                        console.error(error);
                        showErrorMessage({ message: "分野の取得に失敗しました。", error });
                        setSkillMapField({} as SkillMapFieldTree);
                        sompoContext.setSkillMapLoading(false);
                    }
                };
                fetch();
            } else {
                setTimeout(() => {
                    sompoContext.setSkillMapLoading(false);
                }, 500);
            }
        } else {
            setSkillMapField({} as SkillMapFieldTree);
            sompoContext.setSkillMapLoading(false);
        }
    }, [cmId]);

    // 再帰的にnumの値を収集する
    const collectNums = (obj: any): number => {
        let nums: number[] = [];
        // 配列かどうかチェック
        if (Array.isArray(obj)) {
            for (const item of obj) {
                nums = nums.concat(collectNums(item));
            }
            // オブジェクトの場合
        } else if (typeof obj === "object" && obj !== null) {
            // 各プロパティのチェック
            for (const key in obj) {
                if (key === "cellDataNum") {
                    // cellDataNumだったら値をnumsに追加
                    nums.push(Number(obj[key]));
                } else {
                    // cellDataNumではなかったら再度collectNumsを呼ぶ
                    nums = nums.concat(collectNums(obj[key]));
                }
            }
        }
        // 最大値を返す
        return Math.max(...nums);
    };

    // cellDataNumの最大値
    const maxCellDataNum = collectNums(skillMapField.fieldlevelOne);

    // 講座ドロワーを表示する(スキル名押下)タイミングでskillMapCellをfetchする
    const handleTrainingDrawer = (newOpen: boolean, fieldId: string, fieldLevel: string, fieldTitle: string, firstFieldId: string) => () => {
        if (!Environments.MOCK) {
            sompoContext.setSkillMapDrawerLoading(true);
            const fetch = async () => {
                if (Environments.DEBUG) {
                    await new Promise((resolve) => {
                        setTimeout(resolve, 250);
                    });
                }

                const needCompulsoryId: { careerId: string; careerType: string }[] = [];
                await skillMapCellService.skillMapCell(
                    { cmId, fieldId, fieldLevel },
                    (_skillMapCell: SkillMapCellResponse) => {
                        setSkillMapCell(_skillMapCell);
                        setSkillMapFieldTitle(fieldTitle);

                        // compulsoryIdListを作成する
                        _skillMapCell.cellData?.map((d) => {
                            d.cellSubCareer.map((item) => {
                                needCompulsoryId.push({ careerId: item.careerId, careerType: item.careerTypeId });
                            });
                        });

                        setRootId(firstFieldId);
                        // fetchに成功したら講座ドロワーを表示する
                        setTrainingDrawerOpen(newOpen);
                    },
                    (error: any) => {
                        console.error(error);
                        showErrorMessage({ message: "認定条件の取得に失敗しました。", error });
                        sompoContext.setSkillMapDrawerLoading(false);
                    }
                );

                await skillMapRootDataService.skillMapRootData(
                    { cmId, rootId: firstFieldId },
                    (_skillMapRootData: SkillMapRootDataResponse) => {
                        setSkillMapRootData(_skillMapRootData);
                    },
                    (error: any) => {
                        console.error(error);
                        showErrorMessage({ message: "分野の取得に失敗しました。", error });
                        sompoContext.setSkillMapDrawerLoading(false);
                    }
                );

                const list: { [careerId: string]: any } = {};
                await Promise.all(
                    needCompulsoryId.map(async (e: { careerId: string; careerType: string }) => {
                        try {
                            const { careerId, careerType } = e;
                            switch (careerType) {
                                case CAREER_TYPE_ELEARNING:
                                case CAREER_TYPE_CLASSROOM:
                                    await careerInfoClassInfoService.careerInfoClassInfo(
                                        { careerId },
                                        (response: CareerInfoClassInfoResponse) => {
                                            list[careerId] = response.careerInfoData.compulsoryId;
                                        },
                                        (error: any) => {
                                            throw error;
                                        }
                                    );
                                    break;
                                case CAREER_TYPE_CURRICULUM:
                                    await curriculumService
                                        .fetch({ careerId })
                                        .then((response: CurriculumInfoResponse) => {
                                            list[careerId] = response.curriculumInfo.division;
                                        })
                                        .catch((error: unknown) => {
                                            throw error;
                                        });
                                    break;
                                default:
                                    break;
                            }
                        } catch (error: any) {
                            console.error(error);
                            showErrorMessage({ message: "講座情報の取得に失敗しました。", error });
                            sompoContext.setSkillMapDrawerLoading(false);
                        }
                    })
                );
                const _categories: Categories = await fetchCategories();
                setCompulsoryIdList(list);
                setCategories(_categories);
                sompoContext.setSkillMapDrawerLoading(false);
            };
            fetch();
        } else {
            setTimeout(() => {
                setSkillMapCell({} as SkillMapCellResponse);
            }, 250);
        }
    };

    // 通常のセル
    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#CCCCCC",
        },
        align: "left",
        borderCollapse: "collapse",
        wordBreak: "break-all",
        width: desktop ? "200px" : "150px",
        borderBottom: "1.5px solid #999",
    }));

    // 列固定されたセル
    const StyledStickyTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#CCCCCC",
        },
        position: "sticky",
        left: 0,
        align: "left",
        borderCollapse: "collapse",
        wordBreak: "break-all",
        width: desktop ? "200px" : "150px",
        borderBottom: "1.5px solid #999",
    }));

    // 列固定(ヘッダ専用)
    const StyledHeaderTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#CCCCCC",
        },
        position: "sticky",
        left: 0,
        align: "left",
        borderCollapse: "collapse",
        wordBreak: "keep-all",
        width: desktop ? "200px" : "150px",
        borderBottom: "1.5px solid #999",
        whiteSpace: "nowrap",
    }));

    return (
        <Box
            sx={{
                pointerEvents: sompoContext.loading ? "none" : "auto",
            }}
        >
            {/* スキルマップデータを表示 */}
            <Box sx={{ bgcolor: sompoContext.loading ? "#dddddd" : "fff", p: 3, borderRadius: "7px" }}>
                {sompoContext.loading ? (
                    <SompoLoading position="relative" mt={3} />
                ) : (skillMapNames || []).length > 0 ? (
                    <FilterTag conditionList={skillMapNames} value={cmId} handleChange={handleFilterTagChange} allIsDisplay={false} />
                ) : (
                    <NoData message="表示データがありません" />
                )}
            </Box>

            <Box sx={{ height: "auto", minHeight: "200px", width: "100%", position: "relative" }}>
                {/* fetchが終わるまでローディングアイコンを表示 */}
                {sompoContext.skillMapLoading && <SompoLoading />}

                {/* オブジェクトの中身がある場合のみ、テーブルを表示(今は仮でskillMapField) */}
                {Object.keys(skillMapField).length !== 0 && (
                    <>
                        <Typography variant="h5" sx={{ mt: 4, mb: 4 }}>
                            スキル名をクリックして講座を確認できます。
                        </Typography>

                        {/* 選択されたスキルマップを表示するテーブル */}
                        <TableContainer sx={{ mb: 8, bgcolor: "fff", borderCollapse: "collapse", ...cellBorder }}>
                            <Table
                                sx={{
                                    tableLayout: "fixed",
                                    minWidth: 650,
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <StyledStickyTableCell sx={cellBorder}>
                                            <Typography variant="h5">スキル</Typography>
                                        </StyledStickyTableCell>
                                        {Array.from({ length: maxCellDataNum }, (_, index) => (
                                            <StyledTableCell sx={{ ...cellBorder, textAlign: "center" }}>
                                                <Typography variant="h5"> {`LV.${index + 1}`}</Typography>
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {skillMapField.fieldlevelOne.map((firstField, firstIndex) => (
                                        // 第1階層
                                        <React.Fragment key={firstIndex}>
                                            <TableRow sx={{ ...cellBorder, bgcolor: "pink" }}>
                                                <StyledHeaderTableCell>
                                                    <Typography variant="h4">{firstField.fieldTitle}</Typography>
                                                </StyledHeaderTableCell>
                                                {/* 空のセルを作成 */}
                                                {Array.from({ length: maxCellDataNum }, (_) => (
                                                    <StyledTableCell />
                                                ))}
                                            </TableRow>
                                            {firstField.fieldlevelTwo.map((secondField, secondIndex) => (
                                                // 第2階層
                                                <React.Fragment key={secondIndex}>
                                                    {/* 第3階層目を持つ場合はヘッダー扱いとする */}
                                                    {secondField.fieldlevelThree!.length > 0 ? (
                                                        <TableRow sx={{ ...cellBorder, bgcolor: "#fff" }}>
                                                            <StyledHeaderTableCell>
                                                                <Typography variant="h5">{secondField.fieldTitle}</Typography>
                                                            </StyledHeaderTableCell>
                                                            {/* 空のセルを作成 */}
                                                            {Array.from({ length: maxCellDataNum }, (_) => (
                                                                <StyledTableCell />
                                                            ))}
                                                        </TableRow>
                                                    ) : (
                                                        <TableRow>
                                                            <StyledStickyTableCell sx={{ ...cellBorder, bgcolor: "#fff" }}>
                                                                <Box sx={{ display: "flex", alignItems: "flex-start", flexFlow: "column" }}>
                                                                    <Typography
                                                                        variant="h6"
                                                                        sx={TypographyLinkStyle}
                                                                        onClick={handleTrainingDrawer(
                                                                            true,
                                                                            secondField.fieldId,
                                                                            secondField.fieldLevel,
                                                                            secondField.fieldTitle,
                                                                            firstField.fieldId
                                                                        )}
                                                                    >
                                                                        {secondField.fieldTitle}
                                                                    </Typography>
                                                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#29267A" }}>
                                                                        {`(${secondField.cellDataNum})`}
                                                                    </Typography>
                                                                </Box>
                                                            </StyledStickyTableCell>
                                                            {secondField.cellData?.map((cellData, secondCellDataIndex) => (
                                                                // 内容
                                                                <StyledTableCell key={secondCellDataIndex} sx={cellBorder}>
                                                                    <Typography variant="h6">{cellData.contents}</Typography>
                                                                </StyledTableCell>
                                                            ))}
                                                            {/* 空のセルを作成 */}
                                                            {Array.from({ length: maxCellDataNum - secondField.cellDataNum! }, (_) => (
                                                                <StyledTableCell sx={{ ...cellBorder, bgcolor: "#ddd" }} />
                                                            ))}
                                                        </TableRow>
                                                    )}

                                                    {secondField.fieldlevelThree?.map((thirdField, thirdIndex) => (
                                                        // 第3階層
                                                        <React.Fragment key={thirdIndex}>
                                                            <TableRow>
                                                                <StyledStickyTableCell sx={{ ...cellBorder, bgcolor: "fff" }}>
                                                                    <Box
                                                                        sx={{ display: "flex", alignItems: "flex-start", flexFlow: "column", pl: 2 }}
                                                                    >
                                                                        <Typography
                                                                            variant="h6"
                                                                            sx={{ ...TypographyLinkStyle }}
                                                                            onClick={handleTrainingDrawer(
                                                                                true,
                                                                                thirdField.fieldId,
                                                                                thirdField.fieldLevel,
                                                                                thirdField.fieldTitle,
                                                                                firstField.fieldId
                                                                            )}
                                                                        >
                                                                            {thirdField.fieldTitle}
                                                                        </Typography>
                                                                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#29267A" }}>
                                                                            {`(${thirdField.cellDataNum})`}
                                                                        </Typography>
                                                                    </Box>
                                                                </StyledStickyTableCell>
                                                                {thirdField.cellData?.map((cellData, thirdCellDataIndex) => (
                                                                    // 内容
                                                                    <StyledTableCell key={thirdCellDataIndex} sx={cellBorder}>
                                                                        <Typography variant="h6">{cellData.contents}</Typography>
                                                                    </StyledTableCell>
                                                                ))}
                                                                {/* 空のセルを作成 */}
                                                                {Array.from({ length: maxCellDataNum - thirdField.cellDataNum! }, (_) => (
                                                                    <StyledTableCell sx={{ bgcolor: "#ddd", ...cellBorder }} />
                                                                ))}
                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </Box>

            {/* ドロワーを表示する */}
            <SkillDrawer
                cmId={cmId}
                renderCount={renderCount}
                skillMapFieldTitle={skillMapFieldTitle}
                setRenderCount={setRenderCount}
                setTrainingDrawerOpen={setTrainingDrawerOpen}
                trainingDrawerOpen={trainingDrawerOpen}
                skillMapCell={skillMapCell}
                compulsoryIdList={compulsoryIdList}
                rootId={rootId}
                skillMapRootData={skillMapRootData}
                categories={categories}
            />
        </Box>
    );
};

const SearchBySkill = () => <BaseFrame width="80%" title="スキルから探す" breadcrumbs={[<HomeLink />]} content={<Content />} />;

export default SearchBySkill;
